module.exports={
    "over_size_message":"La imagen que subiste tiene más de 10MB. Comprimiremos su archivo para cargarlo. Haga clic en \"Confirmar\" para continuar con la carga.",
    "file_type_error":"¡El archivo que subiste no es una imagen! Intente cargar de nuevo.",
    "upload_error":"¡Error al Subir! (Código de error: 2000) Vuelva a intentarlo.",
    "watermark_remove_over_size":"La imagen que subiste tiene más de 5MB. Se recomienda que utilice nuestro Compresor de imágenes en línea gratuito. Haz clic para <a class=\"jump-link\" href=\"https://www.anymp4.com/es/image-compressor-online/\">aprender más</a>",
    "watermark_remove_file_type_error":"El archivo que cargó no es una imagen, vuelva a subirlo.",
    "watermark_remove_image_type_error":"El formato de imagen no es compatible. Solo admitimos JPG, JPEG, PNG y BMP.",
    "watermark_remove_upload_error":"Error de reconocimiento (código de error: 2001), inténtelo de nuevo...",
    "watermark_remove_processing":"Procesando imagen...",
    "watermark_remove_not_save":"El área que seleccionó no se conservará. ¿Seguro que quieres recortarlo?",
    "watermark_remove_back_home":"El estado actual no se guardará. ¿Estás seguro de que quieres volver a Inicio?",
    "watermark_remove_new_image":"El estado actual no se guardará. ¿Estás seguro de que quieres elegir una nueva imagen?",
    "watermark_select":"Seleccione",
    "watermark_select_area":"Seleccione el área de la marca de agua que desea borrar antes de hacer clic en Eliminar.",
    "watermark_beyond_12k":"La imagen seleccionada supera los 12K de resolución. Lo sentimos, no podemos procesarlo en este momento.",
    "watermark_beyond_pixel_1":"La resolución de la imagen seleccionada supera el <span>%spx</span><span>&times;%spx</span>. No se puede procesar, seleccione de nuevo.",
    "watermark_beyond_pixel_2":"Los visitantes solo pueden procesar <span>%s</span> imágenes con una resolución superior a <span>%spx</span>x<span>%spx</span>, inicie sesión y continúe usándolas.",
    "watermark_beyond_size_1":"El tamaño de la imagen seleccionada supera el <span>%sMB</span>. No se puede procesar, seleccione de nuevo.",
    "watermark_beyond_size_2":"El tamaño de la imagen seleccionada supera el <span>%sMB</span>, pero los visitantes solo pueden procesar imágenes inferiores al <span>%sMB</span>. Inicie sesión y continúe usando.",
    "no_user_down":"Los visitantes solo pueden descargar <span>%s</span> imágenes con calidad original. Inicie sesión y continúe con la descarga. Además, puede mantener el historial de 7 días después de iniciar sesión. Continúe descargando imágenes que sean <span>%spx</span> anchas o altas.",
    "no_down_rights":"No se pueden descargar imágenes HD con calidad original, ¡actualice su plan! También puede continuar descargando imágenes de baja calidad con <span>%spx</span>.",
    "error_40001":"Error: 40001. Por favor contáctenos",
    "error_40099":"Error: 40099. Por favor contáctenos",
    "down_btn":"La descarga está en preparación, espere un momento...",
    "noRemove_down_btn":"No ha hecho nada para eliminar las marcas de agua. Seleccione la marca de agua que desea eliminar y haga clic en el botón Eliminar. Entonces puedes descargar tu imagen.",
    "history_open":"Abriendo la imagen modificada, espere un momento...",
    "maskRightsMonitor_info":"La página para la actualización de beneficios se ha abierto en una nueva pestaña y su plan se sincronizará automáticamente después de la actualización.",
    "maskLoginMonitor_info":"La página de destino se ha abierto, complete el inicio de sesión en ella. Después de iniciar sesión o registrarse con éxito, esta página se sincronizará automáticamente, no la cierre.",
    "photo_rights_info":"Actualmente se pueden descargar <span><i class=\"num\">2</i> imágenes HD</span> con calidad original. <a href=\"https://account.anymp4.com\" target=\"_blank\">Ver detalles>></a>",
    "rights_original":"Para activar la configuración \"Use la función Image Enhancer para reducir la pérdida de calidad\", debe actualizar su cuenta.",
    "Brush":"Cepillo",
    "Lasso":"Lazo",
    "Polygonal":"Poligonal",
    "Eraser":"Borrador",
    "Free":"Gratis",
    "More":"Más:",
    "Select":"Seleccione",
    "Remove":"Remover",
    "BrushSize":"Tamaño:",
    "AspectRatio":"Relación de aspecto:",
    "Upload":"Nueva foto",
    "History":"Historia",
    "Login":"Acceso",
    "MyAccount":"Mi cuenta",
    "Logout":"Cerrar sesión",
    "Usinghelp":"Usando la ayuda>>",
    "Enhancer":"Use la función Image Enhancer para reducir la pérdida de calidad",
    "Download":"Descargar",
    "Guide":"Guía",
    "Polygonal1":"Poligonal",
    "Polygonal_info":"Haga clic con el botón izquierdo del mouse para identificar un punto a la vez.",
    "Lasso1":"Lazo:",
    "Lasso_info":"Mantenga presionado el botón izquierdo del mouse para enlazar el área de la marca de agua.",
    "Brush1":"Cepillo:",
    "Brush_info":"Mantenga presionado el botón izquierdo del mouse para seleccionar con precisión.",
    "Eraser1":"Borrador:",
    "Eraser_info":"Borre las partes innecesarias del área seleccionada.",
    "Click":"Hacer clic",
    "the":"la",
    "click_info":"para comenzar a borrar la marca de agua no deseada.",
    "PleaseUploadImages":"Por favor, cargue imágenes.",
    "CropInfo":"Una vez que se haya eliminado la marca de agua, puede hacer clic en el botón Recortar para recortar la imagen antes de guardarla, o hacer clic en el botón Descargar para guardar la imagen actual directamente.",
    "Crop":"Cosecha",
    "Back":"Atrás",
    "DownloadCropped":"Descargar recortada",
    "Cancel":"Cancelar",
    "FreeWatermarkRemover":"Eliminador de marcas de agua gratis",
    "Processing":"Procesando...",
    "NewImage":"Nueva imagen",
    "Retry":"Rever",
    "Yes":"Sí",
    "No":"No",
    "FailureFeedback":"Comentarios sobre fallas",
    "removeTip":"Después de seleccionar el área de la marca de agua, haga clic en Eliminar para borrar la marca de agua.",
    "rightDown":"Descargar imágenes de baja calidad",
    "history_will":"Caducará después",
    "Expired":"(Venció)",
	"uploadImage":"Cargar imagen",
    "uploadImageInfo":"¡O suelte su archivo de imagen aquí para eliminar la marca de agua!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain TWO HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Ilimitado",
    "watermark_beyond_pixel_3":"La imagen seleccionada excede la resolución <span>%s&times;%s</span>, primero actualice su plan.",
    "watermark_beyond_size_3":"La imagen seleccionada excede <span>%sMB</span>, primero actualice su plan.",
    "no_user_login":"Los nuevos usuarios que inicien sesión pueden obtener DOS beneficios de descarga de imágenes originales en HD.<span class=\"loginMaskbtn\">Iniciar sesión inmediatamente>></span>",
    "Upgrade":"Potenciar",
    "Loading":"Cargando…",
    "SelectAll":"Seleccionar todo",
    "Open":"Abierto",
    "Delete":"Borrar",
    "Clear":"Borrar inválido",
    "noHistory":"No historia",
    "Close":"Cerca",
    "buyUserInfo":"¡Felicidades! Ha actualizado con éxito. Vuelva a la página de inicio y utilice este producto.",
    "buyNoUserInfo":"¡Felicidades! Ha actualizado con éxito. Los beneficios se vincularon a la dirección de correo electrónico que dejó durante la actualización. Utilice la cuenta registrada o vinculada a la dirección de correo electrónico para <span class=\"loginMaskbtn\">iniciar sesión para usar los beneficios</span>. Si no ha registrado o vinculado una cuenta con la dirección de correo electrónico, <span class=\"registerMaskbtn\">utilice la dirección de correo electrónico para registrar una cuenta</span> o vincule otras cuentas a esta dirección de correo electrónico. dirección de correo para usar los beneficios.",
    "GetStarted":"Empezar",
    "AccessTo":"El acceso a los:",
    "imagesOfwatermarkremoval":"imágenes de eliminación de marca de agua",
    "upTo":"Hasta",
    "perImage":"por imagen",
    "Support":"Apoyo",
    "resolution":"resolución",
    "PrepaidPackage":"Paquete Prepago",
    "PayasYouGo":"Pague sobre la marcha",
    "TaxIncl":"Impuestos incluidos.",
    "Checkout":"Verificar",
    "imagesDay":"imágenes/día",
    "imagesMonthly":"imágenes/mensual",
    "image":"imagen",
    "images":"imágenes",
    "imageSize":"tamaño de la imagen",
    "buyInfo1":"Integraciones de <span>enhancer</span> de terceros",
    "buyInfo2":"El historial de edición es válido durante 7 días",
    "buyInfo3":"Tramitación prioritaria",
    "buyInfo4":"Atención al cliente 7x24",
    "buyInfo5":"Caducó después de 24 horas",
    "buyInfo6":"Sin subscripción. ¡Sin renovación automática!",
    "buyInfo7":"Disponible para usar en cualquier momento para siempre",
    "dayPlan":"Plan de 1 día",
    "Lifetime":"Toda la vida",
}